export const getEnvVariable = (name: string) => {
  const value = process.env[name];

  if (!value) {
    throw new Error(`Unable to get anv variable: "${name}"`);
  }

  return value;
};
